module.exports = __webpack_public_path__ + "static/media/23-min.jpg.49d0eaf6.webp";